import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConvertPhotoService {

  convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader: FileReader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
}
